export default function MemberEmailIcon({ height = 44, width = 44 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 45 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22.5947"
        cy="23.3857"
        r="21.8896"
        stroke="currentColor"
        strokeOpacity="0.65"
      />
      <path
        d="M14.8073 31.1734C14.2719 31.1734 13.8137 30.9829 13.4327 30.602C13.0512 30.2204 12.8604 29.7619 12.8604 29.2265V17.5449C12.8604 17.0095 13.0512 16.5514 13.4327 16.1704C13.8137 15.7888 14.2719 15.598 14.8073 15.598H30.3827C30.9181 15.598 31.3766 15.7888 31.7582 16.1704C32.1391 16.5514 32.3296 17.0095 32.3296 17.5449V29.2265C32.3296 29.7619 32.1391 30.2204 31.7582 30.602C31.3766 30.9829 30.9181 31.1734 30.3827 31.1734H14.8073ZM30.3827 19.4919L23.106 24.0428C23.0249 24.0915 22.9396 24.1278 22.85 24.1518C22.7611 24.1765 22.6761 24.1888 22.595 24.1888C22.5138 24.1888 22.4288 24.1765 22.3399 24.1518C22.2504 24.1278 22.165 24.0915 22.0839 24.0428L14.8073 19.4919V29.2265H30.3827V19.4919ZM22.595 22.4123L30.3827 17.5449H14.8073L22.595 22.4123ZM14.8073 19.4919V19.7352V18.2994V18.3237V17.5449V18.3237V18.3111V19.7352V19.4919V29.2265V19.4919Z"
        fill="currentColor"
        fillOpacity="0.65"
      />
    </svg>
  );
}
